import React from 'react';
import Errorimg from '../Assets/Images/Error collage.png'
import './Error.css';
import Button from '../Components/Comman/Button';


const Error404 = () => {
    return ( <>
     <div className="error-page" dir="rtl" lang="ar">
            <div className="error-container">
                <div className="error-image-wrapper">
                    <img src={Errorimg} alt="خطأ 404" className="error-image" />
                    <div className="error-badge">٤٠٤</div>
                </div>
                <div className="error-content">
                    <h1 className="error-title">الصفحة غير موجودة</h1>
                    <div className="error-actions">
                        <span onClick={() => window.history.back()}>
                            <Button text="رجوع ←" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </> );
}
 
export default Error404;